"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryHOC = void 0;
const react_1 = __importStar(require("react"));
const Sentry = __importStar(require("@sentry/react"));
const useInitialData_1 = __importDefault(require("../../../Hooks/useInitialData"));
const ErrorPageWrapper_1 = __importDefault(require("../../Page/ErrorPage/ErrorPageWrapper"));
const SentryHOC = props => {
    const [isActive, setIsActive] = (0, react_1.useState)(false);
    const initialData = (0, useInitialData_1.default)();
    const environment = initialData === null || initialData === void 0 ? void 0 : initialData.environment;
    (0, react_1.useEffect)(() => {
        if (environment && !isActive && process.env.NODE_ENV === 'production') {
            setIsActive(true);
            Sentry.init({
                dsn: 'https://d22fd3cf5f8943f19fad64b7c3c20cb6@o377843.ingest.sentry.io/4505385454010368',
                integrations: [new Sentry.BrowserTracing()],
                environment: environment,
                tracesSampleRate: 0.001,
                ignoreErrors: [/(Non-Error promise rejection captured)/, /404/, /Cancel/, /canceled/],
            });
        }
    }, [environment, isActive]);
    const errorPage = react_1.default.createElement(ErrorPageWrapper_1.default, null);
    return react_1.default.createElement(Sentry.ErrorBoundary, { fallback: errorPage }, props.children);
};
exports.SentryHOC = SentryHOC;
exports.default = exports.SentryHOC;
